var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8925 18.0357L19.8925 18.0446L18.8925 18.0357ZM4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7V5ZM20 7C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5V7ZM11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10H11ZM9 18C9 18.5523 9.44772 19 10 19C10.5523 19 11 18.5523 11 18H9ZM15 10C15 9.44772 14.5523 9 14 9C13.4477 9 13 9.44772 13 10H15ZM13 18C13 18.5523 13.4477 19 14 19C14.5523 19 15 18.5523 15 18H13ZM18 5.99107L17.8926 18.0268L19.8925 18.0446L20 6.00893L18 5.99107ZM14.8927 21H9V23H14.8927V21ZM4 6V18H6V6H4ZM4 7H5V5H4V7ZM5 7H8V5H5V7ZM8 7H16V5H8V7ZM16 7H19V5H16V7ZM19 7H20V5H19V7ZM9 5.55556C9 4.25163 10.2292 3 12 3V1C9.35256 1 7 2.93212 7 5.55556H9ZM12 3C13.7708 3 15 4.25163 15 5.55556H17C17 2.93212 14.6474 1 12 1V3ZM7 5.55556V6H9V5.55556H7ZM15 5.55556V6H17V5.55556H15ZM9 21C7.34314 21 6 19.6569 6 18H4C4 20.7614 6.23857 23 9 23V21ZM17.8926 18.0268C17.8779 19.6731 16.5391 21 14.8927 21V23C17.6367 23 19.868 20.7885 19.8925 18.0446L17.8926 18.0268ZM9 10V18H11V10H9ZM13 10V18H15V10H13Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDeleteIcon);
export default __webpack_public_path__ + "static/media/action_delete_icon.b55e42e000df1e7ea100ca8440e4fd1e.svg";
export { ForwardRef as ReactComponent };